import { convertLocalDateTimeString } from 'components/Common/Utils/DateUtils';

export function formatSent(value) {
    if (!value) {
        return '';
    }
    try {
        return convertLocalDateTimeString(String(value).replace('Z', ''));
    } catch (error) {
        return '';
    }
}
